import React from 'react';

/* ── Reusable SVG icons ── */
const IconHome = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}>
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);
const IconSun = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}>
    <circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
    <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
  </svg>
);
const IconMoon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}>
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
);
const IconInfo = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}>
    <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
  </svg>
);
const IconMail = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}>
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
  </svg>
);
const IconShield = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);

const AppSidebar = ({
  currentPage,
  onNavigate,
  theme,
  onToggleTheme,
  onShowAbout,
  onShowContact,
  onShowPrivacy,
  isOpen,
  onClose,
}) => {
  return (
    <>
      {/* Mobile backdrop */}
      {isOpen && <div className="sidebar-backdrop" onClick={onClose} />}

      {/* ── Desktop: Collapsible icon sidebar (≥ 1025px) ── */}
      <aside className={`app-sidebar${isOpen ? ' is-open' : ''}`}>
        <div className="sidebar-logo">
          <div className="sidebar-logo-icon">RS</div>
          <div className="sidebar-logo-text-group">
            <div className="sidebar-logo-text">RadioStreamIn</div>
            <div className="sidebar-logo-sub">.com</div>
          </div>
        </div>

        <span className="sidebar-section-label">MyRadio</span>
        <nav className="sidebar-nav">
          <button
            className={`sidebar-nav-item${currentPage === 'home' ? ' active' : ''}`}
            onClick={() => onNavigate('home')}
          >
            <IconHome />
            <span className="sidebar-nav-label">MyRadio</span>
          </button>
        </nav>

        <button className="theme-toggle sidebar-theme-toggle" onClick={onToggleTheme} title="Toggle theme">
          <span className="theme-toggle-icon">
            {theme === 'dark' ? <IconSun /> : <IconMoon />}
          </span>
          <span className="sidebar-nav-label">
            {theme === 'dark' ? 'Light mode' : 'Dark mode'}
          </span>
        </button>

        <div className="sidebar-footer">
          <button className="sidebar-footer-link" onClick={onShowAbout}>
            <IconInfo />
            <span className="sidebar-nav-label">About Us</span>
          </button>
          <button className="sidebar-footer-link" onClick={onShowContact}>
            <IconMail />
            <span className="sidebar-nav-label">Contact</span>
          </button>
          <button className="sidebar-footer-link" onClick={onShowPrivacy}>
            <IconShield />
            <span className="sidebar-nav-label">Privacy Policy</span>
          </button>
        </div>
      </aside>

      {/* ── Tablet: Top Header (768px – 1024px) ── */}
      <header className="app-header">
        <div className="app-header-logo">
          <div className="sidebar-logo-icon app-header-logo-icon">RS</div>
          <span className="app-header-logo-text">
            RadioStreamIn<span className="app-header-logo-sub">.com</span>
          </span>
        </div>

        <nav className="app-header-nav">
          <button
            className={`app-header-nav-item${currentPage === 'home' ? ' active' : ''}`}
            onClick={() => onNavigate('home')}
          >
            MyRadio
          </button>
        </nav>

        <div className="app-header-actions">
          <button className="app-header-action-btn" onClick={onToggleTheme} title={theme === 'dark' ? 'Light mode' : 'Dark mode'}>
            {theme === 'dark' ? <IconSun /> : <IconMoon />}
          </button>
          <button className="app-header-action-btn" onClick={onShowAbout} title="About Us">
            <IconInfo />
          </button>
          <button className="app-header-action-btn" onClick={onShowContact} title="Contact">
            <IconMail />
          </button>
          <button className="app-header-action-btn" onClick={onShowPrivacy} title="Privacy Policy">
            <IconShield />
          </button>
        </div>
      </header>

      {/* ── Mobile: Bottom Navigation (< 768px) ── */}
      <nav className="bottom-nav">
        <button
          className={`bottom-nav-item${currentPage === 'home' ? ' active' : ''}`}
          onClick={() => onNavigate('home')}
          aria-label="MyRadio"
        >
          MyRadio
        </button>
        <button className="bottom-nav-item" onClick={onToggleTheme} aria-label="Toggle theme">
          <span className="bottom-nav-icon">
            {theme === 'dark' ? <IconSun /> : <IconMoon />}
          </span>
          {theme === 'dark' ? 'Light' : 'Dark'}
        </button>
      </nav>
    </>
  );
};

export default AppSidebar;
